/* SNKRSMOOD — Panier coulissant : ajout direct depuis « Complétez votre commande ».
   Les produits a une seule variante sont ajoutes ici ; ceux a plusieurs tailles
   passent par la fenetre de choix rapide (data-snkrsmood-quick-buy, gere par
   snkr-quick-buy.js). Le re-rendu du panier reste celui de cart.js (pubsub). */
(function () {
  'use strict';

  if (window.snkrCartDrawerInitialized) return;
  window.snkrCartDrawerInitialized = true;

  function collectSections() {
    var sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sections } })
    );
    return sections;
  }

  function showError(button, message) {
    var card = button.closest('.snkr-cart__upsell-card');
    if (!card) return;
    var existing = card.querySelector('.snkr-cart__upsell-error');
    if (!existing) {
      existing = document.createElement('p');
      existing.className = 'snkr-cart__upsell-error snkr-cart__hint';
      existing.setAttribute('role', 'alert');
      card.querySelector('.snkr-cart__upsell-info').appendChild(existing);
    }
    existing.textContent = message;
  }

  /* Les ajouts sont serialises : chaque reponse /cart/add.js contient le rendu du tiroir
     a l'instant de CET ajout ; deux ajouts concurrents pourraient publier un rendu perime
     apres un rendu plus recent (article manquant, mauvais total). */
  var queue = Promise.resolve();

  function enqueue(button) {
    var variantId = button.getAttribute('data-variant-id');
    if (!variantId || button.getAttribute('aria-busy') === 'true') return;
    button.setAttribute('aria-busy', 'true');
    queue = queue
      .then(function () {
        /* Le corps du tiroir a pu etre re-rendu entre-temps : on retrouve le bouton par variante.
           Absent = produit deja au panier (exclu de la liste) -> rien a faire. */
        var target = button.isConnected
          ? button
          : document.querySelector('button.snkr-cart__upsell-add[data-variant-id="' + variantId + '"]');
        if (!target) return;
        target.setAttribute('aria-busy', 'true');
        return addVariant(target, variantId);
      })
      .catch(function (error) { console.error('[snkr-cart] queue error', error); });
  }

  async function addVariant(button, variantId) {
    if (!window.FoxTheme || !FoxTheme.routes || !FoxTheme.utils) { button.removeAttribute('aria-busy'); return; }

    var label = button.querySelector('.snkr-cart__upsell-add-label') || button;
    var originalLabel = label.textContent;

    var body = JSON.stringify({
      items: [{ id: Number(variantId), quantity: 1 }],
      sections: collectSections(),
      sections_url: window.location.pathname,
    });

    try {
      var response = await fetch(FoxTheme.routes.cart_add_url, Object.assign({}, FoxTheme.utils.fetchConfig('javascript'), { body: body }));
      var parsed = await response.json();
      if (parsed.status) {
        showError(button, parsed.description || parsed.message || 'Impossible d\u2019ajouter ce produit.');
        return;
      }
      var cartResponse = await fetch(FoxTheme.routes.cart_url, FoxTheme.utils.fetchConfig('json', 'GET'));
      var cartJson = await cartResponse.json();
      cartJson.sections = parsed.sections;

      label.textContent = button.getAttribute('data-label-added') || originalLabel;
      button.classList.add('is-added');

      FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson, source: 'snkr-cart-upsell' });
      document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product: parsed } }));
    } catch (error) {
      console.error('[snkr-cart] add failed', error);
      showError(button, 'Une erreur est survenue. R\u00e9essayez.');
    } finally {
      button.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest ? event.target.closest('button.snkr-cart__upsell-add[data-variant-id]') : null;
    if (!button) return;
    event.preventDefault();
    enqueue(button);
  });
})();
